module.exports = __webpack_public_path__ + "105bbe9e8943f264dba77203219cad14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/Entwicklung_Steuerbelastung_2017-2007-mobile.svg
// module id = 764
// module chunks = 1